import axiosConfig from '../utils/axiosConfigInstance';

const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const popupApis = {
	createPopupApi: data => {
		return axiosConfig.post(`${BASE_URL}/popup/new`, data);
	},

	editPopupApi: (id, popupObject) => {
		return axiosConfig.put(`${BASE_URL}/popup/${id}`, popupObject);
	},

	deletePopupApi: id => {
		return axiosConfig.delete(`${BASE_URL}/popup/${id}`);
	}
};
